var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-input-text', {
    class: _vm.theme.isSelect,
    attrs: {
      "value": _vm.inputValue,
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "caption": _vm.caption,
      "autocomplete": "off",
      "error": _vm.error,
      "name": _vm.name,
      "theme": _vm.theme
    },
    on: {
      "focus": _vm.handleFocus,
      "assistant-outside-click": _vm.handleOutSideClick,
      "blur": _vm.handleBlur
    },
    nativeOn: {
      "mouseleave": function($event) {
        _vm.isInputEnter = false
      },
      "mouseenter": function($event) {
        _vm.isInputEnter = true
      }
    },
    scopedSlots: _vm._u([{
      key: "assistant-action",
      fn: function(props) {
        return [_c('v-icon-button', {
          class: _vm.theme.eventsNone
        }, [_vm._v("\n            keyboard_arrow_down\n        ")])]
      }
    }, {
      key: "assistant",
      fn: function(props) {
        return [(_vm.isOpen) ? _c('div', {
          directives: [{
            name: "shadow",
            rawName: "v-shadow",
            value: (2),
            expression: "2"
          }],
          class: _vm.theme.bgWhite
        }, [_c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_c('v-input-text', {
          on: {
            "input": _vm.handleSearch
          },
          model: {
            value: (_vm.searchQuery),
            callback: function($$v) {
              _vm.searchQuery = $$v
            },
            expression: "searchQuery"
          }
        }, [_c('template', {
          slot: "prefix",
          scopedSlots: _vm._u([{
            key: "assistant-action",
            fn: function(props) {
              return [_c('v-icon-button', {
                class: _vm.theme.eventsNone
              }, [_vm._v("\n                                keyboard_arrow_down\n                            ")])]
            }
          }])
        })], 2)], 1), _vm._v(" "), _c('div', {
          class: _vm.theme.fixedHeight
        }, [_c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }]
        }, [(_vm.altItem) ? _c('v-checkbox', {
          attrs: {
            "data": _vm.altItem
          },
          model: {
            value: (_vm.altChecked),
            callback: function($$v) {
              _vm.altChecked = $$v
            },
            expression: "altChecked"
          }
        }, [_c('v-text', {
          slot: "label"
        }, [_vm._v("\n                            " + _vm._s(_vm.altItem.name) + "\n                        ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.filteredItems.length === 0) ? _c('div', _vm._l((_vm.items), function(item, index) {
          return _c('div', {
            directives: [{
              name: "margin",
              rawName: "v-margin.bottom",
              value: (1),
              expression: "1",
              modifiers: {
                "bottom": true
              }
            }],
            key: item.id || index
          }, [_c('v-checkbox', {
            attrs: {
              "data": item
            },
            model: {
              value: (_vm.checked),
              callback: function($$v) {
                _vm.checked = $$v
              },
              expression: "checked"
            }
          }, [_c('v-text', {
            slot: "label"
          }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")])], 1)], 1)
        })) : _c('div', _vm._l((_vm.filteredItems), function(item, index) {
          return _c('div', {
            directives: [{
              name: "margin",
              rawName: "v-margin.bottom",
              value: (1),
              expression: "1",
              modifiers: {
                "bottom": true
              }
            }],
            key: item.id || index
          }, [_c('v-checkbox', {
            attrs: {
              "data": item
            },
            model: {
              value: (_vm.checked),
              callback: function($$v) {
                _vm.checked = $$v
              },
              expression: "checked"
            }
          }, [_c('v-text', {
            slot: "label"
          }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")])], 1)], 1)
        }))]), _vm._v(" "), _c('v-button', {
          attrs: {
            "primary": "",
            "disabled": _vm.checked.length > _vm.maxSelectItems || (_vm.altChecked.length > 0 && _vm.checked.length > 0)
          },
          on: {
            "click": _vm.handleChoose
          }
        }, [_vm._v("\n                выбрать\n            ")])], 1) : _vm._e()]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa7de71a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/InputMultiple/InputMultiple.vue
// module id = 541
// module chunks = 0